import { API_BASE_URL } from "src/config/apiBase";
import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { User, Calendar, Tag, Eye } from "lucide-react";
import ReactionBar from "./ReactionBar";
import CommentSection from "./CommentSection";
import ShareButtons from "./ShareButton";
import { datalist } from "framer-motion/client";
import BlogImageSlider from "./BlogImageSlider";
import draftToHtml from "draftjs-to-html";
import { decryptToken } from "../utils/getToken";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import DOMPurify from "dompurify";



const parseContent = (content) => {
    try {
        // first parse
        let parsed = JSON.parse(content);

        // if result is still a string (double-encoded), parse again
        if (typeof parsed === "string") {
            parsed = JSON.parse(parsed);
        }

        return parsed;
    } catch {
        return content;
    }
};

const toYouTubeEmbed = (url) => {
    if (!url) return null;

    if (url.includes("youtu.be/")) {
        return `https://www.youtube.com/embed/${url.split("youtu.be/")[1].split("?")[0]}`;
    }

    if (url.includes("watch?v=")) {
        return `https://www.youtube.com/embed/${url.split("watch?v=")[1].split("&")[0]}`;
    }

    return null;
};


const AdminBlogDetail = () => {
    const { slug, id } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const url = API_BASE_URL
    const [view, setView] = useState(0)
    const [showPasswordPopup, setShowPasswordPopup] = useState(false);
    const [enteredPassword, setEnteredPassword] = useState("");
    const [isProtected, setProtected] = useState(false);
    const token = decryptToken("accessToken") || ""
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");

    const handleUnlock = async () => {
        try {
            const res = await fetch(`${url}/api/blog/unlock/${blog.slug}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({ password: enteredPassword }),
            });
            const data = await res.json();
            if (res.ok && data.data) {
                setBlog(data.data);
                setProtected(false);
                setShowPasswordPopup(false);
            } else {
                alert(data.error || "Incorrect password ❌");
            }
        } catch (err) {
            alert("Error verifying password");
        }
    };


    const fetchView = async () => {
        try {
            const response = await fetch(`${url}/view-blog/${id}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
            const res = await response.json();
            console.log(res);
            setView(res.views)
        } catch (error) {
            console.log(error)
        }
    }


    useEffect(() => {
        if (!id) return;

        const storedBlogKey = `blog_${id}`;
        const storedBlogData = localStorage.getItem(storedBlogKey);

        if (storedBlogData) {
            const parsed = JSON.parse(storedBlogData);
            // setBlog(parsed.blog);
            fetchNewBlog();
            setLoading(false);
            // console.log(`Loaded blog ${id} from localStorage`);
        } else {
            fetchBlog();
        }
    }, [id]);

    // const fetchBlog = async () => {
    //     setLoading(true);
    //     setError(false);

    //     try {
    //         const res = await fetch(`${url}/api/blog/single/${id}`);
    //         const datanew = await res.json();

    //         if (!datanew?.data) throw new Error("No data found");

    //         const data = datanew.data;

    //         const parseContent = (content) => {
    //             try {
    //                 let parsed = JSON.parse(content);
    //                 if (typeof parsed === "string") parsed = JSON.parse(parsed);
    //                 return parsed;
    //             } catch {
    //                 return content;
    //             }
    //         };

    //         const fixedSections = data.sections.map((sec) => ({
    //             ...sec,
    //             content: parseContent(sec.content),
    //         }));

    //         setBlog({ ...data, sections: fixedSections });
    //         setLoading(false);

    //         await fetch(`${url}/api/view-blog`, {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify({ blog_id: id, views: 1 }),
    //         });

    //         fetchView();
    //         localStorage.setItem(`blog_${id}`, JSON.stringify({ blog: data, viewed: true }));

    //     } catch (err) {
    //         console.error("Error loading blog:", err);
    //         setError(true);
    //         setLoading(false);
    //     }
    // };

    // const fetchNEwBlog = async () => {
    //     const res = await fetch(`${url}/api/blog/single/${id}`);
    //     const datanew = await res.json();
    //     const data = datanew.data;

    //     const parseContent = (content) => {
    //         try {
    //             let parsed = JSON.parse(content);
    //             if (typeof parsed === "string") parsed = JSON.parse(parsed);
    //             return parsed;
    //         } catch {
    //             return content;
    //         }
    //     };

    //     const fixedSections = data.sections.map((sec) => ({
    //         ...sec,
    //         content: parseContent(sec.content),
    //     }));
    //     console.log(fixedSections)
    // }

    const fetchBlog = async () => {
        setLoading(true);
        setError(false);

        try {
            const res = await fetch(`${url}/blog/single/${id}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const datanew = await res.json();

            if (!datanew?.data) throw new Error("No data found");

            const data = datanew.data;

            if (data.visibility === "Password") {
                setProtected(true);
                setShowPasswordPopup(true);
                setBlog(data); // just keep slug/id handy
                setLoading(false);
                return;
            }

            const parseContent = (content) => {
                try {
                    let parsed = JSON.parse(content);
                    if (typeof parsed === "string") parsed = JSON.parse(parsed);
                    return parsed;
                } catch {
                    return content;
                }
            };

            const fixedSections = data.sections.map((sec) => ({
                ...sec,
                content: parseContent(sec.content),
            }));

            setBlog({ ...data, sections: fixedSections });
            setLoading(false);

            await fetch(`${url}/view-blog`, {
                method: "POST",
                headers: { "Content-Type": "application/json" ,
                    Authorization:`Bearer ${token}`
                },
                body: JSON.stringify({ blog_id: id, views: 1 }),
            });

            fetchView();
        } catch (err) {
            console.error("Error loading blog:", err);
            setError(true);
            setLoading(false);
        }
    };



    console.log(blog)

    const fetchNewBlog = async () => {
        try {
            const res = await fetch(`${url}/blog/single/${id}`,{
                method:"GET",
                headers:{
                    "Authorization":`Bearer ${token}`
                }
            });
            const datanew = await res.json();

            if (!datanew?.data) throw new Error("No data found");

            const data = datanew.data;

            const parseContent = (content) => {
                try {
                    let parsed = JSON.parse(content);
                    if (typeof parsed === "string") parsed = JSON.parse(parsed);
                    return parsed;
                } catch {
                    return content;
                }
            };

            const fixedSections = data.sections.map((sec) => ({
                ...sec,
                content: parseContent(sec.content),
            }));

            setBlog({ ...data, sections: fixedSections });
        } catch (error) {

        }
    }
    useEffect(() => {
        fetchView();
        // fetchBlog();
    }, [])




    if (loading)
        return <p className="text-center text-[#4e59c2]">Loading blog...</p>;
    if (error || !blog)
        return <p className="text-center text-red-500">Blog not found.</p>;






    const formattedDate = new Date(
        blog.publishedAt || blog.createdAt
    ).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
    });

    // Helper to render DraftJS-like JSON descriptions
    // const renderDescription = (content) => {
    //     if (!content) return null;

    //     // 🔹 If it's a string, parse it
    //     let parsed;
    //     try {
    //         parsed = typeof content === "string" ? JSON.parse(content) : content;
    //     } catch (e) {
    //         console.error("Invalid JSON in section content:", e);
    //         return <p>{content}</p>;
    //     }

    //     if (parsed?.blocks?.length) {
    //         return parsed.blocks.map((block, idx) => (
    //             <p key={idx} style={{ fontSize: "14px", color: "#000", lineHeight: "1.6" }}>
    //                 {block.text}
    //             </p>
    //         ));
    //     }

    //     return <p>{String(content)}</p>;
    // };


    const renderDescription = (content) => {
        if (!content?.blocks) return null;

        const html = draftToHtml(
            content,
            {},
            false,
            (entity, text) => {
                if (entity.type === "EMBEDDED_LINK") {
                    const embedUrl = toYouTubeEmbed(entity.data.src);

                    return `
          <div style="margin:24px 0; position:relative; padding-top:56.25%;">
            <iframe
              src="${embedUrl}"
              style="position:absolute; top:0; left:0; width:100%; height:100%;"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        `;
                }

                return text;
            }
        );

        return (
            <div
                className="blog-content"
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(html, {
                        ADD_TAGS: ["iframe"],
                        ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "src", "style"],
                    }),
                }}
            />
        );
    };


    // Sort sections by "order"
    const sortedSections = [...(blog.sections || [])].sort(
        (a, b) => a.order - b.order
    );



    // Extract category and tags
    const categories =
        blog.categories?.map((c) => c.categoryDetails?.name).join(", ") ||
        "Uncategorized";
    const tags =
        blog.tags?.map((t) => t.tagDetails?.name).join(", ") || "No tags";

    return (
        <div className="max-w-3xl mx-auto px-4 py-8 text-black">

            {blog.isFeatured && (
                <span className="mb-4 inline-block rounded-full bg-[#e2e7f7] px-3 py-1 text-xs font-medium text-[#4449b1]">
                    🔥 Featured
                </span>
            )}

            {/* Title */}
            <h1 className="text-2xl font-bold text-black mb-4">{blog.title}</h1>

            {/* Meta Info */}
            <div className="flex flex-wrap gap-4 text-sm text-gray-600 mb-5">
                <span className="flex items-center gap-1">
                    <User size={14} /> {blog.author_name || "Unknown Author"}
                </span>
                <span className="flex items-center gap-1">
                    <Calendar size={14} /> {formattedDate}
                </span>
                <span className="flex items-center gap-1">
                    <Tag size={14} /> {categories}
                </span>
                <span className="flex items-center gap-1">
                    <Eye size={14} /> {view || 0} views
                </span>
            </div>

            {/* Main Feature Image */}
            {blog.feature_image && (
                <img
                    src={`${url}${blog.feature_image}`}
                    alt="Primary"
                    className="w-full rounded-lg shadow mb-6"
                />
            )}

            {/* Dynamic Sections */}
            <div className="prose max-w-none mb-6">
                {sortedSections.map((section) => {
                    switch (section.type) {
                        case "description":
                            return (
                                <div key={section.id} className="mb-6">
                                    {renderDescription(section.content)}
                                </div>
                            );

                        // case "image":
                        //     // Normalise images → always an array
                        //     const images = Array.isArray(section.content.images)
                        //         ? section.content.images
                        //         : section.content.url
                        //             ? [{ url: section.content.url, title: section.content.title }]
                        //             : [];

                        //     return (
                        //         <div key={section.id} className="my-6">
                        //             {/* SINGLE IMAGE */}
                        //             {images.length === 1 && (
                        //                 <>
                        //                     <img
                        //                         src={images[0].url}
                        //                         alt={images[0].title || "Blog Image"}
                        //                         className="w-full rounded-lg shadow"
                        //                     />
                        //                     {images[0].title && (
                        //                         <p className="text-sm text-center text-gray-600 mt-2">
                        //                             {images[0].title}
                        //                         </p>
                        //                     )}
                        //                 </>
                        //             )}

                        //             {/* MULTIPLE IMAGES → KEEN SLIDER */}
                        //             {images.length > 1 && (
                        //                 <BlogImageSlider images={images} />
                        //             )}
                        //         </div>
                        //     );

                        case "image":
                            const images = Array.isArray(section.content.images)
                                ? section.content.images.map(img => ({
                                    url: img.url,
                                    title: img.title || ""
                                }))
                                : [];

                            return (
                                <div key={section.id} className="my-6">

                                    {/* SINGLE IMAGE */}
                                    {images.length === 1 && (
                                        <>
                                            <img
                                                src={`${url}${images[0].url}`}
                                                alt={images[0].title || "Blog Image"}
                                                className="w-full rounded-lg shadow"
                                            />
                                            {images[0].title && (
                                                <p className="text-sm text-center text-gray-600 mt-2">
                                                    {images[0].title}
                                                </p>
                                            )}
                                        </>
                                    )}

                                    {/* MULTIPLE IMAGES */}
                                    {images.length > 1 && <BlogImageSlider images={images} />}
                                </div>
                            );

                        case "button":
                            return (
                                <div key={section.id} className="text-center my-8">
                                    <a
                                        href={section.content?.action}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="inline-block bg-[#4e59c2] text-white text-sm font-medium px-5 py-2.5 rounded-lg shadow hover:bg-[#4449b1] transition"
                                    >
                                        {section.content?.text || "Click Here"}
                                    </a>
                                </div>
                            );

                        default:
                            return null;
                    }
                })}

            </div>

            {/* Tags */}
            <div className="mt-8">
                <h4 className="text-sm font-semibold mb-2 text-gray-700">Tags:</h4>
                <div className="flex flex-wrap gap-2">
                    {blog.tags?.map((tag) => (
                        <span
                            key={tag.id}
                            className="bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded-full"
                        >
                            #{tag.tagDetails?.name}
                        </span>
                    ))}
                </div>
            </div>

            {/* Reactions, Comments, Share */}
            <div className="mt-10">
                <ReactionBar blogId={blog?.id} />
                <CommentSection slug={blog?.id} />
                <ShareButtons
                    blogUrl={window.location.href}
                    blogTitle={blog.title}
                />
            </div>
        </div>
    );
};

export default AdminBlogDetail;
